import { useState } from 'react';
import { useStateValue } from '../../index';
import { setRecommendationFeedback } from '../actions';
import { saveRecommendationFeedback } from '../queries';
import { onException } from '../../httpStatusHandler';

/**
 * @typedef {(
 *   rating: number,
 *   reasonCode?: string,
 *   comment?: string
 * ) => Promise<unknown>} rateRecommendation
 */

/**
 * @param {Object.<string, unknown>} recommendation
 * @returns {[{up: number, down: number, my_rating: number|null}, boolean, rateRecommendation]}
 */
export const useRecommendationFeedback = (recommendation) => {
  const [state, dispatch] = useStateValue();
  const [loading, setLoading] = useState(false);

  /** @type {rateRecommendation} */
  const rate = (rating, reasonCode, comment) => {
    setLoading(true);
    return saveRecommendationFeedback(recommendation.declaration_id, rating, reasonCode, comment)
      .then(({ data }) => {
        dispatch(setRecommendationFeedback(data.declaration_id, data.up, data.down, data.rating));
        setLoading(false);
      })
      .catch(errorObject => {
        setLoading(false);
        // 429 (revote cooldown) is handled inline by the caller with a dedicated dialog -
        // the generic toast here is meant for direct API callers, not the UI flow.
        if (errorObject.response?.status !== 429) {
          onException(errorObject, dispatch, state);
        }
        return Promise.reject(errorObject);
      });
  };

  const feedback = recommendation.feedback || { up: 0, down: 0, my_rating: null };
  return [feedback, loading, rate];
};
export default useRecommendationFeedback;